import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetPlannedTaskRemark = (taskId, taskLevel, scheduleHasRemark, enabled) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.Remark, taskId], () => {
        const scheduleRemarkPromise = scheduleHasRemark
            ? api.base.get(`${config.appUrls.tasks}/api/taskschedules/Remark/${taskId}`)
            : Promise.resolve({ data: null });
        const taskRemarkPromise = api.base.get(`${config.appUrls.tasks}/api/plannedTasks/Remark/${taskId}?taskLevel=${taskLevel}`);
        return Promise.all([
            taskRemarkPromise,
            scheduleRemarkPromise,
        ]).then(([{ data: remark }, { data: scheduleRemark }]) => ({ remark, scheduleRemark }));
    }, {
        enabled,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
